import {
  ProcessFlowchartNodeDetailsType,
  ProcessFlowchartPlatformFeatureType,
} from 'graphql-client/__generated/graphqlGlobalTypes';
import {FlowchartFeatures} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/FlowchartFeaturesContext';
import {PLUGIN_REGISTRY_INSTANCE} from 'processes/graph-builder-processes/platform/PluginRegistry';

import {NodeSettingsTabKeys, SidepanelTab} from './processFlowchartConfigEditorConstants';
import {
  FlowchartNode,
  isStaticTaskSchemaNodeData,
  StaticFlowchartNodeData,
} from './processFlowchartConfigEditorNodeTypes';
import {PROCESS_FLOWCHART_SIDEPANEL_TAB_BY_PLATFORM_FEATURE} from './sidepanelTabsByPlatformFeature';

export function getAllNodeDetailsSidepanelTabsForTaskNodeData(
  nodeData: StaticFlowchartNodeData,
  flowchartFeatures?: FlowchartFeatures
): Array<SidepanelTab> {
  if (!isStaticTaskSchemaNodeData(nodeData)) {
    return [];
  }
  const adapter = PLUGIN_REGISTRY_INSTANCE.getTaskSchemaNodeAdapter(
    nodeData.taskDefinitionVersionSpec.newProcessTaskDefinitionVersion.taskSchema.executionType
  );
  const tabs = [...adapter.nodeDetailsSidepanelContent];

  if (flowchartFeatures == null) {
    return tabs;
  }

  for (const platformFeature of Object.values(ProcessFlowchartPlatformFeatureType)) {
    if (
      flowchartFeatures.get(platformFeature) === true &&
      PROCESS_FLOWCHART_SIDEPANEL_TAB_BY_PLATFORM_FEATURE[platformFeature] != null
    ) {
      tabs.push(...PROCESS_FLOWCHART_SIDEPANEL_TAB_BY_PLATFORM_FEATURE[platformFeature]);
    }
  }
  return tabs.map((tab) =>
    tab.key === NodeSettingsTabKeys.INPUT_OUTPUT_FIELDS &&
    nodeData.nodeDetailsType === ProcessFlowchartNodeDetailsType.OUTPUT_NODE_DETAILS
      ? {...tab, label: 'Outputs'}
      : tab
  );
}

export default function getAllNodeDetailsSidepanelTabsForTaskNode(
  node: FlowchartNode,
  flowchartFeatures?: FlowchartFeatures
): Array<SidepanelTab> {
  return getAllNodeDetailsSidepanelTabsForTaskNodeData(node.data, flowchartFeatures);
}
